var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCommentMarker = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2.5 3A2.5 2.5 0 0 0 0 5.5v5A2.5 2.5 0 0 0 2.5 13H6v1.942a.98.98 0 0 0 1.625.738L10.688 13h.812a2.5 2.5 0 0 0 2.5-2.5v-5A2.5 2.5 0 0 0 11.5 3z",
  className: "CommentMarker_svg__glyph-inner"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M7 12v2.898L10.312 12H11.5a1.5 1.5 0 0 0 1.5-1.5v-5A1.5 1.5 0 0 0 11.5 4h-9A1.5 1.5 0 0 0 1 5.5v5A1.5 1.5 0 0 0 2.5 12zm.625 3.68A.98.98 0 0 1 6 14.942V13H2.5A2.5 2.5 0 0 1 0 10.5v-5A2.5 2.5 0 0 1 2.5 3h9A2.5 2.5 0 0 1 14 5.5v5a2.5 2.5 0 0 1-2.5 2.5h-.812z",
  className: "CommentMarker_svg__glyph-outer",
  clipRule: "evenodd"
})));
export default SvgCommentMarker;